import styled from 'styled-components';
import { match } from 'styled-is';
import { motion } from 'framer-motion';
import {
    largeUp,
    xLargeUp,
    mediumUp
} from '@honeybook/hbui/dist/styles/breakpoints';
import { TCardSize } from '../../../CreateFlow/types/create-flow.types';

export const Cards = styled(motion.div)<{
    size?: TCardSize;
}>`
    display: grid;

    ${match('size', 'md')`
        gap: 24px;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, minmax(280px, 280px));
        ${mediumUp}{
            justify-content: flex-start;
        }
    `}

    ${match('size', 'lg')`
        grid-template-columns: minmax(0, 1fr);
        grid-gap: 48px;
        margin: 0 auto;
        
        ${largeUp} {
            grid-template-columns: repeat(1, 438px);
        }
        
        ${xLargeUp} {
            gap: 50px;
            margin: 0;
            grid-template-columns: repeat(2, 438px);
            justify-content: space-between;
        }
    `}
`;
